import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, FormHelperText, Link, Stack } from '@mui/material'

import { PhoneEntryBox } from '~components/common'
import { Button, InputLabelStyled, TextField } from '~components/internal'

import GreetingField from './GreetingField'

export interface PhoneSettingsStepProps {
  number: string
  onNumberChange: (number: string, isValid: boolean) => void
  name: string
  onNameChange: (name: string) => void
  defaultTransferLine: string
  onDefaultTransferLineChange: (number: string, isValid: boolean) => void
  defaultGreetingMessage: string
  onDefaultGreetingMessageChange: (message: string) => void
  voicemailProcess: { name: string; url: string; isDraft: boolean } | null
  isCreatingVoicemailProcess: boolean
  onCreateVoicemailProcess: () => void
}

const PhoneSettingsStep: React.FC<PhoneSettingsStepProps> = ({
  number,
  onNumberChange,
  name,
  onNameChange,
  defaultTransferLine,
  onDefaultTransferLineChange,
  defaultGreetingMessage,
  onDefaultGreetingMessageChange,
  voicemailProcess,
  isCreatingVoicemailProcess,
  onCreateVoicemailProcess,
}) => {
  return (
    <Stack spacing={2}>
      <Box className='phone-line-dialog__field-row'>
        <Box sx={{ flex: '0 0 auto' }}>
          <InputLabelStyled shrink className='phone-line-dialog__label'>
            Phone Number
          </InputLabelStyled>
          <PhoneEntryBox inputPhoneState={number} includeExt={false} onChange={onNumberChange} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <TextField
            label='Name'
            placeholder='Enter a name for the phone line'
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
          />
        </Box>
      </Box>

      <Box>
        <InputLabelStyled shrink className='phone-line-dialog__label'>
          Default Transfer Line
        </InputLabelStyled>
        <PhoneEntryBox
          inputPhoneState={defaultTransferLine}
          onChange={onDefaultTransferLineChange}
        />
      </Box>

      <GreetingField
        label='Default greeting message'
        id='default-greeting'
        value={defaultGreetingMessage}
        onChange={onDefaultGreetingMessageChange}
        placeholder='Enter the default greeting message...'
      />

      <Box>
        <InputLabelStyled shrink className='phone-line-dialog__label'>
          Voicemail Intake
        </InputLabelStyled>
        {voicemailProcess ? (
          <Link component={RouterLink} to={voicemailProcess.url} target='_blank'>
            {voicemailProcess.name}
            {voicemailProcess.isDraft && ' (Draft — make any required edits before going live)'}
          </Link>
        ) : (
          <Button
            disabled={isCreatingVoicemailProcess}
            onClick={onCreateVoicemailProcess}
            variant='outlined'
            size='small'
          >
            Create Voicemail Intake
          </Button>
        )}
        <FormHelperText>
          Fallback for transferred calls if no default transfer line is set.
        </FormHelperText>
      </Box>
    </Stack>
  )
}

export default PhoneSettingsStep
